const checkIfIsChild = (parent: Node, node: Node) => {
  return parent?.contains(node)
}

export default checkIfIsChild
